import { useAnnouncementList } from "../../hooks/api/v2/announcement/useAnnouncementList";
import { useNotificationList } from "../../hooks/api/v2/notification/useNotificationList";

export const useRetailerNotificationIndicator = () => {
  const polling = {
    refetchInterval: 10 * 60 * 1000,
    refetchIntervalInBackground: false,
  };
  const notifications = useNotificationList(
    {
      query: [
        { type: "priority", value: "high", modifier: "EQUALS" },
        { type: "unRead", value: true, modifier: "EQUALS" },
      ],
      limit: 1,
    },
    polling,
  );
  const announcements = useAnnouncementList(
    {
      query: [{ type: "unRead", value: true, modifier: "EQUALS" }],
      limit: 1,
    },
    polling,
  );
  return Boolean(
    notifications.data?.pages[0]?.length ||
    announcements.data?.pages[0]?.length,
  );
};
